import { useGetApiV1PersonIdRoles } from '@/shared/api/generated';

/**
 * Busca os vínculos/papéis de uma pessoa via `/api/v1/person/:id/roles`.
 * Desabilitado enquanto `personId` for `undefined`.
 *
 * @param personId - ID da pessoa. `undefined` desabilita a requisição.
 * @returns Query com `PersonRolesViewModel` e estados de loading/error.
 *
 * @example
 * ```tsx
 * const { data, isLoading } = usePersonRoles(person.id);
 * ```
 */
export function usePersonRoles(personId: number | undefined) {
  return useGetApiV1PersonIdRoles(personId ?? 0, {
    query: { enabled: !!personId },
  });
}
